import { Center } from '@mantine/core';
import { FC, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Contact, ContactsColumnVisibility } from '../../Service/ContactS';
import { openEditContactModal } from '../../Organismns/Contact/EditContactModal';
import { ContactsContext } from '../../Service/Context/ContactsContext';
import ContactRowActions from './ContactRowActions';

interface Props extends ContactsColumnVisibility {
  key: string | number;
  contact: Contact;
}

const ContactRow: FC<Props> = ({ key, contact, showMail, showPhone, showGroups }) => {
  const { reload, updateContact } = useContext(ContactsContext);
  const navigate = useNavigate();
  const { id: contactId, personDescription, email, phoneNumber, groups } = contact;

  const edit = () => openEditContactModal(contact, reload, updateContact);

  const openDetails = () => navigate(`${contactId}/details`);

  return (
    <tr key={key}>
      <td onClick={openDetails} style={{ cursor: 'pointer' }}>
        {personDescription ?? email}
      </td>
      {showMail && <td>{email}</td>}
      {showPhone && <td>{phoneNumber}</td>}
      {showGroups && <td>{groups.join(', ')}</td>}
      <td style={{ position: 'relative' }}>
        <Center>
          <div style={{ position: 'absolute', right: 0 }}>
            <ContactRowActions contact={contact} />
          </div>
        </Center>
      </td>
    </tr>
  );
};

export default ContactRow;
